import { FieldValues } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { useCreateSmsSender } from 'api/SendersAPI';
import { ApiError } from 'services/api';
import { useModalsContext, useSendingPlatformsQueryContext } from '../../../../contexts';
import { getPhoneNumberLabelForEspAccount, getSmsSenderTermForEspAccount } from '../../../../utils';
import { SMS_SENDER_FORM_FIELD_NAMES } from '../../../../types';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { MessageTypeField } from './MessageTypeField';
import { SmsSenderModalRHF } from './SmsSenderModalRHF';

const { NAME, PHONE_NUMBER, MESSAGE_TYPE_ID } = SMS_SENDER_FORM_FIELD_NAMES;

type Props = {
  espAccountId: number;
};

const createSmsSenderPayload = (values: FieldValues, espAccountId: number) => {
  const { messageTypeId, ...rest } = values;
  if (messageTypeId) return { ...rest, messageTypeId, espAccountId };
  return { ...rest, espAccountId };
};

export const AddSmsSenderModal = ({ espAccountId }: Props) => {
  const { hideModal } = useModalsContext();
  const dispatch = useDispatch();
  const { selectEspAccount, refetchSmsSenders } = useSendingPlatformsQueryContext();
  const espAccount = selectEspAccount(espAccountId);
  const term = getSmsSenderTermForEspAccount(espAccount);

  const { mutate } = useCreateSmsSender({
    onSuccess: () => {
      refetchSmsSenders();
      dispatch(addPositiveToast(`Successfully created ${term}.`));
      hideModal();
    },
    onError: (e: unknown) => {
      const errorText = (e as ApiError)?.response?.data?.message;
      dispatch(addNegativeToast(errorText));
      hideModal();
    },
  });

  if (!espAccount) return null;

  const onSubmit = (values: FieldValues) => {
    const payload = createSmsSenderPayload(values, espAccountId);
    mutate(payload);
  };

  return (
    <SmsSenderModalRHF
      confirmText={`Create ${term}`}
      headerText={`New ${term}`}
      onSubmit={onSubmit}
    >
      <ConnectedInputField key={NAME} name={NAME} labelText={'Name'} />
      <ConnectedInputField
        name={PHONE_NUMBER}
        labelText={getPhoneNumberLabelForEspAccount(espAccount)}
      />
      <MessageTypeField name={MESSAGE_TYPE_ID} />
    </SmsSenderModalRHF>
  );
};
